module.exports = __webpack_public_path__ + "img/logo-lecos.3dd43b53.svg";